/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Viestin tiedot',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Virhe',
    FETCH_DATA: 'Hae tiedot',
    NO_ORDER: 'Mitään palstaa ei voitu piirtää'
  },
  HEADER: {
    DATE: 'Päivämäärä',
    MESSAGE: 'Viesti',
    NAME: 'Asiakkaan nimi',
    ORDER_CODE: 'Tilauskoodi',
    ORDER_DATE: 'Tilauspäivä',
    ORDER_ID: 'Tilaa',
    ORDER_VALUE: 'Arvo',
    PAYMENT_DATE: 'Maksupäivä',
    PAYMENT_STATE: 'Maksun tila',
    PRICE: 'Hinta',
    VALUE: 'Arvo'
  },
  LABEL: {
    COPIED: 'Kopioitu!',
    EXPORT: 'Vie',
    GIVEWAY_DATE: 'Arvontapäivä:',
    MONTH: 'Kuukausi',
    ORDER_PRIZE_MSG: 'Palkittu tilaus:',
    PAYED: 'Maksettu',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Maksamaton',
    UNTIL: 'a',
    YEAR: 'Vuosi'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Ei viestejä',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION: 'Ei viestejä asiakkailta (vielä).',
    NO_ROWS_ORDERS: 'Ei tilauksia',
    NO_ROWS_ORDERS_DESCRIPTION: 'Ei tilauksia (vielä).'
  },
  SUCCESS: {
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    DATE: 'Päivämäärä',
    ORDER_CODE: 'Tilauskoodi',
    ORDER_ID: 'Tilaa',
    PAYMENT_DATE: 'Maksupäivä',
    PAYMENT_STATE: 'Maksun tila',
    PRICE: 'Hinta',
    VALUE: 'Arvo'
  }
};
